import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-center text-danger my-2 pt-5" }
const _hoisted_2 = { class: "d-none d-lg-block text-center" }
const _hoisted_3 = { class: "d-none d-sm-block d-lg-none text-center" }
const _hoisted_4 = {
  class: "d-none d-md-block",
  style: {"position":"relative","width":"70%","left":"20%"}
}
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "multiselect__single"
}
const _hoisted_8 = {
  key: 1,
  class: "multiselect__single"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["title"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["href"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { style: {"white-space":"pre"} }
const _hoisted_40 = {
  key: 0,
  style: {"margin-top":"20px","background-color":"orange"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_pagination = _resolveComponent("b-pagination")
  const _component_b_col = _resolveComponent("b-col")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")
  const _component_b_dropdown_form = _resolveComponent("b-dropdown-form")
  const _component_b_dropdown = _resolveComponent("b-dropdown")
  const _component_b_button_group = _resolveComponent("b-button-group")
  const _component_b_tooltip = _resolveComponent("b-tooltip")
  const _component_b_row = _resolveComponent("b-row")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_v_multiselect = _resolveComponent("v-multiselect")
  const _component_b_dropdown_item_button = _resolveComponent("b-dropdown-item-button")
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")
  const _component_b_popover = _resolveComponent("b-popover")
  const _component_b_table = _resolveComponent("b-table")
  const _component_b_overlay = _resolveComponent("b-overlay")
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")
  const _component_b_modal = _resolveComponent("b-modal")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_overlay, {
      show: $data.isLoading || $data.isExporting,
      "no-center": ""
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_spinner, { class: "align-middle" })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_b_row, { class: "mb-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_pagination, {
                  modelValue: $data.currentPage,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.currentPage) = $event)),
                  "total-rows": $options.totalRows,
                  "per-page": $data.perPage,
                  "aria-controls": "my-table",
                  onInput: $options.computeStickyColumnOffsets
                }, null, 8 /* PROPS */, ["modelValue", "total-rows", "per-page", "onInput"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_2, " Gefiltert: " + _toDisplayString($options.totalRows) + " / Gesamt: " + _toDisplayString($data.employees.length), 1 /* TEXT */),
                _createElementVNode("h3", _hoisted_3, _toDisplayString($options.totalRows) + " / " + _toDisplayString($data.employees.length), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($data.filters), (key) => {
                    return (_openBlock(), _createElementBlock("span", { key: key }, [
                      ($data.filters[key].type === 'multiselect' && $data.filters[key].value.length)
                        ? (_openBlock(), _createBlock(_component_b_button, {
                            key: 0,
                            class: "filter-button",
                            onClick: $event => ($options.clearFilter(key))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.getLabel(key)) + " ", 1 /* TEXT */),
                              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */))
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                        : ($data.filters[key].type !== 'multiselect' && $data.filters[key].value !== '')
                          ? (_openBlock(), _createBlock(_component_b_button, {
                              key: 1,
                              class: "filter-button",
                              onClick: $event => ($options.clearFilter(key))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.getLabel(key)) + " ", 1 /* TEXT */),
                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */))
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                          : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_button_group, { class: "float-end flex-sm-nowrap" }, {
                  default: _withCtx(() => [
                    (!$data.showInactive)
                      ? (_openBlock(), _createBlock(_component_b_button, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = $event => ($options.toggleInactive()))
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "fas fa-eye" }, null, -1 /* CACHED */),
                            _createElementVNode("span", { class: "d-none d-xl-inline-block ms-1" }, "Inaktive anzeigen", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    ($data.showInactive)
                      ? (_openBlock(), _createBlock(_component_b_button, {
                          key: 1,
                          onClick: _cache[2] || (_cache[2] = $event => ($options.toggleInactive()))
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "fas fa-eye-slash" }, null, -1 /* CACHED */),
                            _createElementVNode("span", { class: "d-none d-xl-inline-block ms-1" }, "Inaktive verbergen", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _withDirectives((_openBlock(), _createBlock(_component_b_button, { id: "btn-copy-mails" }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })), [
                      [
                        _directive_b_modal,
                        void 0,
                        void 0,
                        { "email-modal": true }
                      ]
                    ]),
                    _createVNode(_component_b_dropdown, {
                      id: "btn-choose-columns",
                      "auto-close": "outside",
                      right: "",
                      class: "btn-group"
                    }, {
                      "button-content": _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "fas fa-th-list" }, null, -1 /* CACHED */)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_component_b_dropdown_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_checkbox, {
                              id: "columnCheckbox",
                              switch: "",
                              onChange: _cache[3] || (_cache[3] = $event => ($options.resetVisibleFields()))
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" Alle Spalten ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_b_dropdown_divider),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectableFields, (field) => {
                              return (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                key: field.key,
                                modelValue: field.visible,
                                "onUpdate:modelValue": $event => ((field.visible) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(field.label || field.key), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_b_button, {
                      id: "btn-export-employees",
                      onClick: _cache[4] || (_cache[4] = $event => ($options.downloadEmployees()))
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fas fa-download" }, null, -1 /* CACHED */),
                        _createElementVNode("i", { class: "fas fa-file-excel" }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_b_button, {
                      id: "btn-clear-filters",
                      title: "Alle Filter löschen",
                      onClick: _cache[5] || (_cache[5] = $event => ($options.clearFilters()))
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                        _createElementVNode("i", { class: "fas fa-filter" }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                ($data.employeesSelected.length)
                  ? (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 0,
                      target: "btn-copy-mails",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode(" Uni-E-Mail-Adressen der ausgewählten Mitarbeiter*innen anzeigen ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 1,
                      target: "btn-copy-mails",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Uni-E-Mail-Adressen " + _toDisplayString($options.filteredEmployees.length !== $data.employees.length ? 'der gefilterten' : 'aller') + " Mitarbeiter*innen anzeigen ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })),
                ($data.employeesSelected.length)
                  ? (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 2,
                      target: "btn-export-employees",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" Ausgewählte Einträge als Excel-Datei herunterladen ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 3,
                      target: "btn-export-employees",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.filteredEmployees.length !== $data.employees.length ? 'Gefilterte' : 'Alle') + " Einträge als Excel-Datei herunterladen ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_table, {
            id: "employee-table",
            ref: "table",
            busy: $data.isLoading,
            "onUpdate:busy": _cache[9] || (_cache[9] = $event => (($data.isLoading) = $event)),
            class: "bootstrap-vue-table-borders",
            "busy.sync": "isLoading",
            small: "",
            striped: "",
            hover: "",
            responsive: "",
            fixed: "",
            "sticky-header": "100%",
            "primary-key": "id",
            fields: $options.visibleFields,
            items: $options.filteredEmployees,
            "per-page": $data.perPage,
            "current-page": $data.currentPage,
            selectable: "",
            "select-mode": "multi",
            "no-select-on-click": "",
            "onUpdate:selectedItems": $options.onRowSelected,
            onSortChanged: $options.computeStickyColumnOffsets
          }, {
            "head()": _withCtx(({ field }) => [
              _createElementVNode("div", {
                title: field.title
              }, _toDisplayString(field.label), 9 /* TEXT, PROPS */, _hoisted_6),
              _createElementVNode("div", null, [
                ($data.filters[field.key] && $data.filters[field.key].type === 'string-contains')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 0,
                      modelValue: $data.filters[field.key].value,
                      "onUpdate:modelValue": $event => (($data.filters[field.key].value) = $event),
                      type: "text",
                      size: "sm",
                      placeholder: "Suchen...",
                      debounce: "200",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("v-if", true),
                ($data.filters[field.key] && $data.filters[field.key].type === 'string-equals')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 1,
                      modelValue: $data.filters[field.key].value,
                      "onUpdate:modelValue": $event => (($data.filters[field.key].value) = $event),
                      type: "text",
                      size: "sm",
                      placeholder: "Gleich...",
                      debounce: "200",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("v-if", true),
                ($data.filters[field.key] && $data.filters[field.key].type === 'multiselect')
                  ? (_openBlock(), _createBlock(_component_v_multiselect, {
                      key: 2,
                      modelValue: $data.filters[field.key].value,
                      "onUpdate:modelValue": $event => (($data.filters[field.key].value) = $event),
                      options: $data.filters[field.key].dynamicOptions,
                      multiple: true,
                      "track-by": "id",
                      label: "name",
                      "close-on-select": false,
                      "show-pointer": false,
                      "selected-label": "✓",
                      placeholder: "Filtern...",
                      onOpen: $event => ($options.calculateDynamicFilterOptions(field.key)),
                      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      selection: _withCtx(({ values, isOpen }) => [
                        (values.length > 1 && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(values.length) + " Werte", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (values.length === 1 && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(values[0].short || values[0].name), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9))
                      ]),
                      beforeList: _withCtx(() => [
                        _createElementVNode("li", {
                          class: "multiselect__option",
                          onClick: $event => ($options.resetMultiselect($data.filters[field.key]))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                          _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_10)
                      ]),
                      noResult: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode(" Keine Inhalte gefunden. ", -1 /* CACHED */)
                      ]))]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options", "onOpen"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            "cell(checkbox)": _withCtx(({ index, rowSelected }) => [
              _createVNode(_component_b_form_checkbox, {
                checked: rowSelected,
                inline: "",
                onChange: $event => ($options.toggleSelection(index))
              }, null, 8 /* PROPS */, ["checked", "onChange"])
            ]),
            "cell(edit)": _withCtx(({item}) => [
              _createVNode(_component_b_dropdown, {
                text: "Aktion wählen",
                size: "sm",
                lazy: "lazy"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_dropdown_item_button, {
                    onClick: $event => ($options.copyAddressToClipboard(item.address))
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("i", { class: "far fa-copy" }, null, -1 /* CACHED */),
                      _createTextVNode(" Anschrift kopieren ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"]),
                  _createVNode(_component_b_dropdown_item, {
                    href: 'employee/'+item.id+'/edit'
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */),
                      _createTextVNode(" Bearbeiten ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"]),
                  ($data.deletePermission)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_divider, { key: 0 }))
                    : _createCommentVNode("v-if", true),
                  ($data.deletePermission)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 1,
                        "data-href": 'employee/'+item.id+'/delete',
                        class: "dropdown-item-danger",
                        variant: "white",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#confirm-delete"
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("i", { class: "fas fa-trash" }, null, -1 /* CACHED */),
                          _createTextVNode(" Löschen ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["data-href"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            "cell(name)": _withCtx(({ item, value }) => [
              (item['detailsUrl'])
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item['detailsUrl'],
                    target: "_blank"
                  }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_11))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(value), 1 /* TEXT */))
            ]),
            "cell(emailWWU)": _withCtx(({value}) => [
              value
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    title: value
                  }, [
                    ($data.filters['emailWWU'].value === '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createElementVNode("a", {
                            href: 'mailto:' + value
                          }, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_15)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createElementVNode("a", {
                            href: 'mailto:' + value
                          }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_17)
                        ]))
                  ], 8 /* PROPS */, _hoisted_13))
                : _createCommentVNode("v-if", true)
            ]),
            "cell(emailPrivate)": _withCtx(({value}) => [
              value
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    title: value
                  }, [
                    ($data.filters['emailPrivate'].value === '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _createElementVNode("a", {
                            href: 'mailto:' + value
                          }, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_20)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                          _createElementVNode("a", {
                            href: 'mailto:' + value
                          }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_22)
                        ]))
                  ], 8 /* PROPS */, _hoisted_18))
                : _createCommentVNode("v-if", true)
            ]),
            "cell(begin)": _withCtx(({item, value }) => [
              (item['active_contracts'] === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "inaktiv"))
                : (value.length === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(value[0]), 1 /* TEXT */))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(value, (elem, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: elem.index
                      }, [
                        _createTextVNode(_toDisplayString(elem) + " [" + _toDisplayString(index+1) + "]", 1 /* TEXT */),
                        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
            ]),
            "cell(end)": _withCtx(({item, value }) => [
              (item['active_contracts'] === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "inaktiv"))
                : (value.length === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(value[0]), 1 /* TEXT */))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(value, (elem, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: elem.index
                      }, [
                        (elem !== '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(elem) + " [" + _toDisplayString(index+1) + "]", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
            ]),
            "cell(next_level_date)": _withCtx(({item, value }) => [
              (item['active_contracts'] !== 0 && value.length === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(value[0]), 1 /* TEXT */))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(value, (elem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: elem.index
                    }, [
                      (elem !== '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(elem) + " [" + _toDisplayString(index+1) + "]", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
            ]),
            "cell(follow_up_contracts)": _withCtx(({value}) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            "cell(rentals)": _withCtx(({ item, value }) => [
              (item['rentalUrls'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (elem, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("a", {
                          href: item['rentalUrls'][index]
                        }, _toDisplayString(elem), 9 /* TEXT, PROPS */, _hoisted_31)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (elem, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(elem), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
            ]),
            "cell(roomBookingGroups)": _withCtx(({item, value}) => [
              (item['roomBookingGroupUrls'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (name, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("a", {
                          href: item['roomBookingGroupUrls'][index],
                          target: "_blank"
                        }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_34)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (name, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(name), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
            ]),
            "cell(bank)": _withCtx(({value}) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  item
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _createTextVNode(_toDisplayString(item), 1 /* TEXT */),
                        _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            "cell(note)": _withCtx(({value, index: row}) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  item
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createVNode(_component_b_button, {
                          id: 'note-btn-row' + row + '-i' + index,
                          title: "Hinweis"
                        }, {
                          default: _withCtx(() => [
                            _cache[30] || (_cache[30] = _createTextVNode(" anzeigen ", -1 /* CACHED */)),
                            (value.length !== 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "[" + _toDisplayString(index+1) + "]", 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]),
                        _createVNode(_component_b_popover, {
                          target: 'note-btn-row' + row + '-i' + index,
                          placement: "top",
                          click: "",
                          lazy: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            "cell()": _withCtx(({value}) => [
              _createElementVNode("span", _hoisted_39, _toDisplayString(value), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["busy", "fields", "items", "per-page", "current-page", "onUpdate:selectedItems", "onSortChanged"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_b_modal, {
      id: "email-modal",
      title: "E-Mail Adressen",
      "ok-only": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form_textarea, {
          "model-value": $options.combinedMailAddresses.join('; ')
        }, null, 8 /* PROPS */, ["model-value"]),
        ($options.combinedMailAddresses.length !==
          ($data.employeesSelected.length ? $data.employeesSelected.length : $options.filteredEmployees.length))
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Achtung: Die Uni-E-Mail von " + _toDisplayString(($data.employeesSelected.length?$data.employeesSelected.length:$options.filteredEmployees.length)-$options.combinedMailAddresses.length) + " der ausgewählten Mitarbeiter*innen wurde nicht angegeben! ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}